export default {
  en: {
    toggleLight: 'Toggle Light',
    toggleDark: 'Toggle Dark',
  },
  'zh-TW': {
    toggleLight: '拨动灯',
    toggleDark: '切换黑暗',
  },
};
